import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class BayanWayBill extends Model {
  @Expose()
  waybillId: number;
  @Expose()
  fromCity: string;
  @Expose()
  toCity: string;
  @Expose()
  isActive: boolean;
}
